import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Menu, Dropdown, Button } from 'antd';
import styled from 'styled-components';
import { CloseOutlined } from '@ant-design/icons';
import { startCase, toLower } from 'lodash';
import filterLogo from 'assets/filter.svg';
import pendingFilter from 'assets/Pending.svg';
import { Image, Flex } from 'atoms';
import noInvoice from 'assets/no-invoice.svg';
import {
	brandBasedFilter,
	getSalesMen,
	getNoInvoiceMen,
	multipleStatusFilter,
	setFilteredSalesMen,
	setIsNoInvoicesMen,
	setAdditionalFilter,
	setChosenColor,
} from 'store/invoiceSlice';
import { SalesMenSearch } from 'components/pages/sales-men';

const FBtn = styled(Button)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 42px;
	padding: 0;
	border: 0.66px solid #000000;
	border-radius: 2.66px;
	text-align: center;
`;

const FBtnDashed = styled(Button)`
	width: 40px;
	height: 42px;
	padding: 0;
	border: 0.66px dashed #000000;
	border-radius: 2.66px;
	line-height: 50px;
	text-align: center;
	// margin-left: 0.5rem;
`;

const MenuContainer = styled(Menu)`
	li {
		width: 95%;
		margin: auto;
		padding: 10px;
		border-bottom: 0.05em solid rgba(203, 203, 203, 1);
		span {
			font-size: 12px;
			line-height: 16px;
			font-weight: 300;
		}
		&:last-child {
			border-bottom: 0;
		}
	}
`;

export default function SalesMenFilter() {
	const {
		brandNames = [],
		salesMen = [],
		isNoInvoicesMen,
		additionalFilter = false,
		chosenColor,
	} = useSelector((state) => state.invoice);
	const [selectedBrand, setSelectedBrand] = useState();

	const dispatch = useDispatch();

	const resetSalesman = () => {
		dispatch(setFilteredSalesMen(salesMen));
	};

	const handleBrandNameBasedSalesMen = ({ key }) => {
		dispatch(brandBasedFilter(key));
		setSelectedBrand(key);
		dispatch(setIsNoInvoicesMen(false));
	};

	function resetFilter() {
		setSelectedBrand(null);
		dispatch(getSalesMen(true));
		dispatch(setIsNoInvoicesMen(false));
	}

	function noInvoicesMen() {
		setSelectedBrand(null);
		if (additionalFilter) {
			dispatch(setAdditionalFilter(false));
			resetSalesman();
		}

		if (chosenColor) {
			dispatch(setChosenColor(''));
			resetSalesman();
		}
		if (isNoInvoicesMen) {
			dispatch(getSalesMen(true));
		} else {
			resetSalesman();
			dispatch(getNoInvoiceMen());
		}
		dispatch(setIsNoInvoicesMen(!isNoInvoicesMen));
	}

	const statusBaseFilter = () => {
		if (isNoInvoicesMen) {
			dispatch(setIsNoInvoicesMen(false));
			resetSalesman();
		}
		if (chosenColor) {
			dispatch(setChosenColor(''));
			resetSalesman();
		}
		if (additionalFilter) {
			dispatch(getSalesMen(true));
		} else {
			resetSalesman();
			dispatch(multipleStatusFilter());
		}
		dispatch(setAdditionalFilter(!additionalFilter));
	};

	const menu = (
		<MenuContainer onClick={handleBrandNameBasedSalesMen}>
			{brandNames?.map((brand) => (
				<Menu.Item key={brand?.brand_id}>{startCase(toLower(brand?.brand_name))}</Menu.Item>
			))}
		</MenuContainer>
	);

	return (
		<Flex justifyContent="space-between" alignItems="flex-end" mb="1.5rem">
			<SalesMenSearch />
			{selectedBrand ? (
				<FBtn onClick={resetFilter} type="primary">
					<CloseOutlined style={{ fontSize: '18px' }} />
				</FBtn>
			) : (
				<Dropdown trigger={['click']} overlay={menu} placement="bottomLeft" arrow>
					<FBtn title="Brand Filter">
						<Image src={filterLogo} alt="Filter Logo" height={20} width={20} />
					</FBtn>
				</Dropdown>
			)}
			<FBtnDashed
				title="No Invoices"
				onClick={noInvoicesMen}
				type={isNoInvoicesMen ? 'primary' : 'none'}
			>
				<Image src={noInvoice} alt="no Invoice Logo" height={20} width={20} />
			</FBtnDashed>
			<FBtnDashed
				title="Pending Invoices"
				onClick={statusBaseFilter}
				type={additionalFilter ? 'primary' : 'none'}
			>
				<Image src={pendingFilter} alt="no Invoice Logo" height={20} width={20} />
			</FBtnDashed>
		</Flex>
	);
}
